import Vue from 'vue';
import cookie from '@/services/cookie';
import 'moment/locale/zh-hk';

// add translations directly to the application
Vue.i18n.add('en', require('./en.json'));
// Vue.i18n.add('es', require('./es.json'));
Vue.i18n.add('zh', require('./zh.json'));

// set the start locale to use
Vue.i18n.set(cookie.get('locale') || 'zh');

// set fallback for non-translated strings
Vue.i18n.fallback('en');
Vue.i18n.translateObj = Vue.prototype.$tObj = function (obj, def = obj) {
  if (!obj) return def;
  for (let l of [Vue.i18n.locale()].concat(Vue.i18n.locales())) {
    if (obj[l]) return obj[l];
  }
  return def;
};



// WEBPACK FOOTER //
// ./src/i18n/index.js